import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/what-we-store.jpg'),
    alt: 'what we store page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'what we store page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'What Items <span>We Store Safely</span> <span>To Make Life Easier</span>',
  description:
    'Discover secure and reliable storage solutions at ShipAndStorage. From moving boxes to luggage, sports gear to office documents, we provide safe spaces for all your storage needs. ',
  image: {
    url: '/images/v2/pages/main-pages/what-we-store/hero-image.jpg',
    alt: 'what we store page'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Secure Space' }
}

export const serviceTipsSectionContent = {
  title: 'How It Works',

  cards: [
    {
      id: 1,
      title: 'Pack Your Items',
      description:
        'Carefully pack your belongings using durable materials to ensure they stay safe during transportation and storage.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/pack-your-items.svg',
        alt: 'Pack Your Items'
      }
    },
    {
      id: 2,
      title: 'Schedule Pickup',
      description:
        'Select a convenient date and time for our team to collect your items right from your doorstep, hassle-free.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/schedule-pickup.svg',
        alt: 'Schedule Pickup'
      }
    },
    {
      id: 3,
      title: 'We Store & Deliver',
      description:
        'Your belongings are securely stored in our facilities and promptly delivered back to you when needed.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/we-store-deliver.svg',
        alt: 'We Store & Deliver'
      }
    }
  ]
}

export const infoTabsSectionSectionContent = {
  title: 'Different Storage Services We Offer',
  description: 'We provide you with a number of storage services at your convenience.',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Book Storage' },

  articles: [
    {
      id: 1,
      title: 'Moving Box Storage',
      points: [
        '<strong>Flexible Durations:</strong> Need short-term or long-term storage? We’ve got you covered.',
        '<strong>Safe & Secure:</strong> Your items are stored in monitored, climate-controlled facilities.',
        '<strong>Hassle-Free Retrieval:</strong> Access your boxes anytime with our convenient delivery options.'
      ],
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/moving-box-storage.png',
        alt: 'Moving Box Storage'
      }
    },
    {
      id: 2,
      title: 'Luggage Storage',
      points: [
        '<strong>Versatile Solutions:</strong> Ideal for vacations, business trips, or downsizing your living space.',
        '<strong>24/7 Security:</strong> Advanced monitoring ensures your luggage stays safe.',
        '<strong>Convenient Access:</strong> Retrieve your items quickly and easily when needed.'
      ],
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/luggage-storage.png',
        alt: 'Luggage Storage'
      }
    },
    {
      id: 3,
      title: 'Sports Gear Storage',
      points: [
        '<strong>Seasonal Solutions:</strong> Perfect for storing skis, snowboards, golf clubs, and more.',
        '<strong>Climate Control:</strong> Prevents damage from humidity and temperature fluctuations.',
        '<strong>Effortless Retrieval:</strong> Access your gear whenever you’re ready to hit the slopes or the course.'
      ],
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/sports-gear-storage.png',
        alt: 'Sports Gear Storage'
      }
    },
    {
      id: 4,
      title: 'Office Document Storage',
      points: [
        '<strong>Confidentiality First:</strong> Advanced security systems ensure your sensitive information is protected.',
        '<strong>Organized Storage:</strong> Easily retrieve files when needed without the clutter.',
        '<strong>Flexible Access:</strong> Request deliveries of stored documents as required.'
      ],
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/office-document-storage.png',
        alt: 'Office Document Storage'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Additional Storage Options',
  description: 'Beyond the essentials, we provide tailored solutions for unique storage needs:',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Seasonal Storage',
          description: 'Store your holiday decorations, patio furniture, or seasonal clothing until needed.'
        },
        {
          id: 2,
          title: 'Student Storage',
          description: 'Affordable storage solutions for students during summer breaks or moving between dorms.'
        },
        {
          id: 3,
          title: 'Furniture Storage',
          description: 'Keep bulky furniture safe during renovations, relocations, or temporary downsizing.'
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/additional-storage-options.svg',
        alt: 'Additional Storage Options'
      }
    }
  ]
}

export const whyChooseShipAndStorageSectionContent = {
  title: 'Why Choose ShipAndStorage?',
  description:
    'Choosing ShipAndStorage means partnering with a service that prioritizes safety, affordability, and convenience for all your storage needs.',

  cards: [
    {
      id: 1,
      title: 'Top-Notch Security',
      description:
        'Enjoy 24/7 monitoring and climate-controlled facilities that keep your items safe and well-preserved.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/top-notch-security.svg',
        alt: 'Top-Notch Security'
      }
    },
    {
      id: 2,
      title: 'Affordable Pricing',
      description: 'Benefit from transparent, competitive rates designed to fit your budget without hidden fees.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/affordable-pricing.svg',
        alt: 'Affordable Pricing'
      }
    },
    {
      id: 3,
      title: 'Flexible Storage Plans',
      description: 'Choose from customizable short-term or long-term solutions that work around your schedule.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/flexible-storage-plans.svg',
        alt: 'Flexible Storage Plans'
      }
    },
    {
      id: 4,
      title: 'Convenient Pickup & Delivery',
      description: 'We manage the logistics, picking up your items and delivering them back when you need them.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/convenient-pickup-delivery.svg',
        alt: 'Convenient Pickup & Delivery'
      }
    },
    {
      id: 5,
      title: 'Nationwide Availability',
      description: 'Access our reliable storage and delivery services from any location across the country.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/nationwide-availability.svg',
        alt: 'Nationwide Availability'
      }
    },
    {
      id: 6,
      title: 'Expert Customer Support',
      description: 'Our friendly team is always available to answer questions and assist you.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-store/expert-customer-support.svg',
        alt: 'Expert Customer Support'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'What We Store Safely in Facilities',
  description:
    'Find out what items we can store, including business and personal items. Secure and flexible storage options available.',
  image: {
    src: '/images/v2/pages/main-pages/what-we-store/promotional-banner-image.svg',
    alt: 'What We Store Safely in Facilities'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Store With Us' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'What items can I store with ShipAndStorage?',
      answer:
        'We store a wide variety of items, including moving boxes, luggage, sports gear, office documents, seasonal decorations, furniture, and more.'
    },
    {
      id: 2,
      question: 'Are my belongings safe at your facilities?',
      answer:
        'Yes, our facilities are monitored 24/7 with advanced security systems, and climate control ensures your items remain in pristine condition.'
    },
    {
      id: 3,
      question: 'How long can I store my items?',
      answer:
        'We offer flexible storage durations, from short-term solutions to long-term plans tailored to your needs.'
    },
    {
      id: 4,
      question: 'Can I access my items whenever I need them?',
      answer: 'Absolutely! You can request delivery or pickup of your stored items at any time.'
    },
    {
      id: 5,
      question: 'What are the costs associated with storage?',
      answer:
        'Our pricing is transparent and affordable, with no hidden fees. Contact us for a custom quote based on your storage requirements.'
    }
  ]
}
